import React from "react";
import classNames from "classnames";
import { useAggregatedFiltersContext } from "@components/pageHeader/filters/AggregatedFilters/AggregatedFilters.context";
import styles from "./FiltersOverlay.module.scss";

export const FilterNavTab: React.FC<{
    eventKey: string;
    children: React.ReactNode;
    className?: string;
}> = ({ eventKey, children, className }) => {
    const { activeTab, open } = useAggregatedFiltersContext();
    return (
        <button
            type="button"
            className={classNames(className, {
                [styles.active]: activeTab === eventKey,
            })}
            onClick={() => open(eventKey)}
        >
            {children}
        </button>
    );
};
